const initialState = { DateFormat: "DD/MM/YYYY" };

export default function(state = initialState, action) {
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/systemConfig.js